export default __webpack_public_path__ + "static/media/folder.a9013835.svg";